export const selectIntegrationLogs = state => state.integrationLogs.data
